import axios from 'axios';
import { Observable } from './Observable';
import Subscriber from 'live/services/subscription'
import HardwareInformation from './../interfaces/HardwareInformation';

const axiosInstance = axios.create({baseURL: '/services/plugin-widget-gmaps'})
const url = '/services/plugin-groovy/subscription/fleetTracking/hardwares'
const subscriber = new Subscriber({url})

export class CacheFleetTracking{

    isLoadingVehicles: boolean
    observable: Observable    
    hardwareData: any;
    
    constructor(){
        this.isLoadingVehicles = true;
        this.hardwareData = {};
        this.observable = new Observable();
        this.loadCacheVehicle()
        this.loadCacheHardware()
    }

    private loadCacheVehicle = () => {
        return axiosInstance.get('/vehicle').then(response => {            
            this.isLoadingVehicles = false
            this.observable.notify({vehicles: response.data})   
            // this.updateCacheVehicle()       
        })
    }

    private loadCacheHardware = () => {
        return axiosInstance.get('/hardware').then(response => {
            this.hardwareData = this.toHardwareData(response.data)
            this.observable.notify({hardwares: this.hardwareData})          
            this.updateCacheHardware()
        })
    }

    private toHardwareData = (data) => {
        const map = {}            

        data.forEach(ele => {
            const { keyMatch } = ele
            map[keyMatch] = ele
        })

        return map
    }

    // private updateCacheVehicle = () => {
    //     const url = '/services/plugin-groovy/subscription/fleetTracking/vehicles'
    //     const subscriber = new Subscriber({url})
    //     subscriber.close()

    //     subscriber.on('event', events => {    
    //        this.observable.notify({vehicles: response.data})     
    //     })

    //     subscriber.flush()
    // }

    private updateCacheHardware = () => {       
        subscriber.close()

        subscriber.on('event', events => {                      
            const ele = events[0]
            if(ele?.keyMatch) this.hardwareData[ele.keyMatch] = ele
        })

        setInterval(() => {
            this.observable.notify({hardwares: this.hardwareData})
        }, 30000);

        subscriber.flush()
    }
}